import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import asset from '../../../images/asset-management.jpeg';
import legend from '../../../images/services/operation/250_660549931.jpg';
import power from '../../../images/services/operation/251_271820135.jpg';
import renew from '../../../images/services/operation/252_112485596.jpg';
import subs from '../../../images/services/operation/253_1_700075405.jpg';
import '../../../styles/mainItem.css'

const OMServices = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };
    return (
        <div className='main-page'>
            <Image src={legend} fluid className="mainItemPage-img" />
            <div className='sub-items'>
                <Container>
                    <h1 className='mb-4'>Operation & Maintenance Services</h1>
                    <hr className='mb-4' />
                    <Row className='justify-content-md-start'>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/operation-maintenance-services/power-plants" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Power Plants</p>
                                    <div className='card-image-frame'>
                                        <Image src={power} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/operation-maintenance-services/renewable-power-plants" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Renewable Power Plants</p>
                                    <div className='card-image-frame'>
                                        <Image src={renew} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/operation-maintenance-services/substations" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Substations</p>
                                    <div className='card-image-frame'>
                                        <Image src={subs} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default OMServices